var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"outlined":"","dense":"","hide-details":"auto","item-text":"name","item-value":"id","label":_vm.label,"require":"","items":_vm.items,"rules":_vm.rules,"disabled":_vm.disabled},model:{value:(_vm.selectItem),callback:function ($$v) {_vm.selectItem=$$v},expression:"selectItem"}})
}
var staticRenderFns = []

export { render, staticRenderFns }